var React = require("react");
var Dropdown = require('../../deploynaut/js/components/Dropdown.jsx');
var ToggleBox = require('../../deploynaut/js/components/ToggleBox.jsx');
const createReactClass = require("create-react-class");

var WAFConfig = createReactClass({

	getInitialState: function() {
		return {
			SecurityID: this.props.model.InitialSecurityID,
			Enabled: this.props.model.Enabled,
			WAF: JSON.parse(JSON.stringify(this.props.model.WAF)),
			WAFOptions: JSON.parse(JSON.stringify(this.props.model.WAFOptions)),
			NeedFullDeploy: this.props.model.NeedFullDeploy,
			RedeployLink: this.props.model.RedeployLink,
			DomainsLink: this.props.model.DomainsLink,
			SSLLink: this.props.model.SSLLink,
			Message: {type: 'success', body: ''},
			Loading: false,
			Whitelist: this.props.model.hasWhitelist,
			FullDeployNeededMessage: 'A <a href=' + this.props.model.RedeployLink + '>full deployment</a> is required to complete the changes requested.'
		};
	},

	request: function(url, postData) {
		var self = this;
		return Q($.ajax({
			type: "POST",
			url: url,
			data: postData
		}))
			.then(function(data) {
				self.setState({
					WAF: data.WAF,
					WAFOptions: data.WAFOptions,
					Enabled: data.Enabled,
					NeedFullDeploy: data.NeedFullDeploy,
					SecurityID: data.NewSecurityID,
					Loading: data.Loading,
					Message: {type: 'danger', body: ''}
				});
			})
			.fail(function(data) {
				self.setState({
					Message: {type: 'danger', body: data.responseText},
					Loading: false
				});
			});
	},

	setWAF: function(waf) {
		this.setState({
			Loading: true
		});
		this.request(
			this.props.model.UpdateAction,
			{
				Details: JSON.stringify(waf),
				DispatcherSecurityID: this.state.SecurityID
			}
		);
	},

	toggleWAF: function() {
		this.setState({
			Loading: true
		});
		if(this.state.Enabled) {
			this.disableWAF();
		} else {
			this.enableWAF();
		}
	},

	enableWAF: function() {
		return this.request(
			this.props.model.EnableAction,
			{
				DispatcherSecurityID: this.state.SecurityID
			}
		);
	},

	disableWAF: function() {
		return this.request(
			this.props.model.DisableAction,
			{
				DispatcherSecurityID: this.state.SecurityID
			}
		);
	},

	render: function() {
		var instructions = '';
		if (this.state.WAF !== 'none' && this.state.Enabled === false) {
			instructions = (
				<div className="waf-config-alert">
					<div className='alert alert-warning'>
						Your WAF selection has been set to <strong>{this.state.WAF}</strong>.
						<br />
						Before enabling this WAF, please ensure that your DNS is now configured correctly.
						See the <a href={this.state.DomainsLink}>Domains tab</a> for your new configuration details.
						<br/>
						You may also need to upload any SSL certificates to your WAF provider.
						A <a href={this.state.RedeployLink}>full deployment</a> will be required to	apply the
						changes once the WAF is enabled.
						<br/>
						If SilverStripe is managing your WAF, this will be taken care of for you.
					</div>
				</div>
			);
		}

		var message = '';
		if (this.state.Message.body !== '') {
			message = (
				<div className="waf-config-alert">
					<div className={"alert alert-" + this.state.Message.type}>
						{this.state.Message.body}
					</div>
				</div>
			)
		}

		if (this.state.Whitelist) {
			return (
				<div className="waf-config">
					<div className="row">
						<div className="col-md-12">
							<p className="alert alert-error">
								You must disable the whitelist before editing the WAF configuration.
							</p>
						</div>
					</div>
				</div>
			);
		}

		return (
			<div className="waf-config">
				<div className="row">
					<div className="col-md-7">
						<p className="waf-description">
							If you are going to have a Web Application Firewall (WAF) configured for your environment,
							please select it from the dropdown below. This will prepare the environment
							to expect the WAF - for more details, please
							see <a href="https://servicedesk.silverstripe.cloud/support/solutions/articles/75000012653-web-application-firewall-waf-">
							the documentation</a>. A full deployment will be required in order to apply the changes
							once the WAF has been enabled
						</p>
						<div>
							<h4>Select WAF</h4>
							{instructions}
							<Dropdown
								name="waf-dropdown"
								options={this.state.WAFOptions}
								defaultValue="none"
								value={this.state.WAF ? this.state.WAF : "none"}
								onSelect={this.setWAF}
								disabled={this.state.Enabled}/>
						</div>
					</div>
					<div className="col-md-5">
						{message}
						<ToggleBox
							className="WAF"
							enabled={this.state.Enabled}
							pending={this.state.NeedFullDeploy}
							onChangeHandler={this.toggleWAF}
							loading={this.state.Loading}
							FullDeployNeededMessage={this.state.FullDeployNeededMessage}
						/>
					</div>
				</div>
			</div>
		);
	}
});

module.exports = WAFConfig;
